module.exports = "/_next/static/videos/footwear-1-df3152b6b4a1651efcda57dd6f8a2b7f.webm";